module.exports = __webpack_public_path__ + "img/forestry-works-logo.4ee8861f.jpg";